// extracted by mini-css-extract-plugin
module.exports = {"deviceName":"HeaderDeviceDetails_deviceName__2CswD","deviceInfos":"HeaderDeviceDetails_deviceInfos__26XSG","tags":"HeaderDeviceDetails_tags__3QbxU"};